<template>
  <div class="story-medium">
    <div class="container-row">
      <div class="move-arrows">
        <button 
          type="button"
          class="btn btn-sm btn-default move-arrow" 
          @click.stop="moveToFirst" 
          data-toggle="tooltip" 
          data-trigger="hover" 
          title="Move to first position"
        >
          <i class="fa fa-angle-up"></i>
        </button>
        <button 
          type="button"
          class="btn btn-sm btn-default move-arrow" 
          @click.stop="moveToLast" 
          data-toggle="tooltip" 
          data-trigger="hover" 
          title="Move to last position"
        >
          <i class="fa fa-angle-down"></i>
        </button>
      </div>
      <div class="image-container">
        <i class="fa fa-arrows handle show-on-hover"></i>
        <img v-if="fileType == 'image'" :src="small_thumb_url" />
        <div class="file-icon" v-if="fileType != 'image'">
          <i class="fa fa-file"></i>
        </div>
      </div>

      <div class="info-container">
        <div class="file-info">
          <div class="filename">{{ mediaFileName }}</div>
          <div 
            class="btn btn-danger" 
            type="button" 
            @click="deleteStoryMedia" 
            data-toggle="tooltip" 
            data-trigger="hover" 
            title="Remove this attachment"
          >
            <i class="fa fa-trash"></i>
          </div>
        </div>
        <div class="checkbox-container">
          <LabelledCheckbox 
            class="form-row-for-print" 
            label="For print" 
            v-model="for_print" 
          />
          <LabelledCheckbox 
            class="form-row-for-web" 
            label="For web" 
            v-model="for_web" 
          />
        </div>
      </div>
      <div class="credit-caption">
        <Input
          type="text"
          v-model="credit"
          placeholder="Credit"
        />
      </div>
      <div class="credit-caption">
        <RichtextEditor
          v-model="cutline"
          placeholder="Cutline"
          classes="form-control-sm"
          :editorId="`media-cutline-${id}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { mediaFileName } from '@/utils/file_helpers'
  import Input from '@/components/shared/input.vue'
  import RichtextEditor from '@/components/shared/richtext_editor'
  import LabelledCheckbox from '@/components/shared/labelled_checkbox.vue'

  export default {
    components: {
      Input,
      RichtextEditor,
      LabelledCheckbox
    },

    props: {
      id: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        // This is a weird hack to make vue-pathify work with variable expansion.
        // See https://github.com/davestewart/vuex-pathify/issues/103.
        storeRootAttr: 'storyMedia'
      }
    },

    computed: {
      ...sync('storyMedia/:storeRootAttr@:id', [
        'for_print',
        'for_web',
        'list_order'
      ]),
      ...sync('storyMedia/:storeRootAttr@:id.medium', [
        'cutline',
        'credit',
        'small_thumb_url',
        'filename',
        'content_type'
      ]),

      fileType() {
        if(this.content_type != null) {
          return this.content_type.split('/')[0]
        }
      },

      mediaFileName() {
        return mediaFileName(this.filename)
      },
    },

    mounted() {
      if(this.$refs.thumbnail) {
        jQuery(this.$refs.thumbnail).tooltip()
      }
      // Initialize tooltips for move buttons
      jQuery(this.$el).find('[data-toggle="tooltip"]').tooltip()
    },

    methods: {
      deleteStoryMedia() {
        if(!confirm(`Sure you want to delete ${this.filename}`)) return

        this.$store.dispatch('storyMedia/destroy', { storyMediumId: this.id })
      },

      moveToFirst() {
        this.$store.dispatch('storyMedia/moveToPosition', { 
          storyMediumId: this.id, 
          position: 'first' 
        })
      },

      moveToLast() {
        this.$store.dispatch('storyMedia/moveToPosition', { 
          storyMediumId: this.id, 
          position: 'last' 
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .story-medium {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 2px solid #c9c9c9;
  }

  .container-row {
    display: grid;
    grid-template-columns: 20px 120px 1fr;
    height: auto;
    gap: 5px;

    .move-arrows {
      display: flex;
      flex-direction: column;
      gap: 6px;
      align-items: flex-start;
      justify-content: flex-start;
      font-weight: bold;
      color: #333;
      position: relative;

      i.fa {
        font-size: 15px;
      }
      .move-arrow {
        padding: 2px 4px;
        min-width: 24px;
        border-radius: 3px;
        border: 1px solid #ccc;
        background-color: rgba(255, 255, 255, 0.9);
        color: #333;
        cursor: pointer;

        &:hover {
          background-color: #f5f5f5;
          border-color: #999;
        }

        &:active {
          background-color: #e5e5e5;
        }

        i {
          margin: 0;
          width: 13px;
          height: 10px;
        }
    }
  }

  .image-container {
    // Image/file icon container
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    font-weight: bold;
    color: #333;

    img {
      max-width: 120px;
      max-height: 120px;
      height: auto;
      display: block;
    }
    
    .handle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 3em;
      color: white;
      text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
      cursor: grab;
      z-index: 10;
    }

    .show-on-hover {
      visibility: hidden;
    }

    &:hover .show-on-hover {
      visibility: visible;
    }
  }

  .info-container {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 0;

    .form-row-for-print, .form-row-for-web {
    margin-left: 0px;
    }
  }

  .file-info {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-weight: bold;
    color: #333;
    gap: 5px;

    .filename {
      flex: 1;
      min-width: 0; // Allow flex item to shrink below content size
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .btn-danger {
      color: #fff;
      background-color: #d9534f;
      border-color: #d43f3a;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0; // Prevent button from shrinking
    }

    .btn-danger:hover {
      background-color: #c9302c;
      border-color: #ac2925;
    }
  }

  .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    font-weight: bold;
    color: #333;
    padding: 5px 0;
    min-height: 30px;
  }

  .credit-caption {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #333;

    span {
      width: 100%;
    }
  }
  .file-icon {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 5px;

    i.fa {
      font-size: 28pt;
      color: rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
